import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectMetadata',
  props: {
    projectDocument: null,
    loading: { type: Boolean },
    containerClass: { default: 'd-flex film-metadata font--genre-small flex-wrap align-center justify-start mx-n3 mx-lg-n4 mb-1' }
  },
  setup(__props: any) {

const props = __props as { projectDocument?: ISanityDocuments[SanityDocumentSchema.PROJECT], loading?: boolean, containerClass: string };



const genres = computed(() => {
  return props.projectDocument?.genres ?? [];
});

const tags = computed(() => {
  return props.projectDocument?.overviewTags ?? [];
});

const schemas = SanityDocumentSchema;

return { __sfc: true,props, genres, tags, schemas }
}

})